var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVrDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4196 11C16.4196 11.2302 16.233 11.4168 16.0028 11.4168C15.7726 11.4168 15.5859 11.2302 15.5859 11C15.5859 10.7698 15.7726 10.5832 16.0028 10.5832C16.233 10.5832 16.4196 10.7698 16.4196 11",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4167 11C11.4167 11.2302 11.2301 11.4168 10.9998 11.4168C10.7696 11.4168 10.583 11.2302 10.583 11C10.583 10.7698 10.7696 10.5832 10.9998 10.5832C11.2301 10.5832 11.4167 10.7698 11.4167 11",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41473 11C6.41473 11.2302 6.22811 11.4168 5.99789 11.4168C5.76768 11.4168 5.58105 11.2302 5.58105 11C5.58105 10.7698 5.76768 10.5832 5.99789 10.5832C6.22811 10.5832 6.41473 10.7698 6.41473 11",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrDots);
export default __webpack_public_path__ + "static/media/vr-dots.a8b9a2283f274e4ff193ad2bc57b54e4.svg";
export { ForwardRef as ReactComponent };